import { errorToast } from "../utils";

export var getAjaxToken = function(){
  return pexam_ajax_object.nonce;
}

export var getAjaxUrl = function(){
  return pexam_ajax_object.ajax_url;
}

export var completedAjax = function(holder){
  removeSpinner(holder);
}

export var sendAjax = function(holder){
  if (holder) {
    showSpinner(holder);
  }
}

export function ajaxRequest(to:string, after = function (resp) {}, data:Object = {}, btn:boolean|JQuery = false, async = true, onError = function(resp){}) {
  const config = {
    data: data,
    type: "POST",
    dataType: "json",
    url: to,
    async: async,
    beforeSend: function(){
      if (btn){
        showSpinner(btn);
      }
    },
    success: function(response){
      if (btn){
        hideSpinner(btn)
      }
      after(response);
    },
    error: function(response){
      if (btn){
        hideSpinner(btn)
      }

      onError(response);

      response = JSON.parse(response['responseText'])
      if ('message' in response){
        errorToast(response['message'])

      } else if ('error' in response){
        errorToast(response['error']);
      } else if ('errors' in response){
        response['errors'].forEach((error:string) => {
          errorToast(error)
        })
      }
    }
  };
  return $.ajax(config);
}


// Man könnte auch alternativ einfach nen spinner im btn anzeigen lassen

export var ajaxConfig = function(config, holder=false){
  config.type = 'POST';
  config.dataType = 'json';
  config.url = getAjaxUrl();
  config.data._ajax_nonce = getAjaxToken();
  config.beforeSend = sendAjax(holder);
  // config.complete = completedAjax(holder);
  return config;
}

export var ajax = function(config, holder=false){
  $.ajax(ajaxConfig(config, holder));
}

export var spinner = function(){
  return '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
}

export var switchOnIconSpinner = function(btn){
  btn.find("i").hide();
  btn.append(spinner());
}

export var switchOffIconSpinner = function(btn){
  btn.find("i").show();
  const spinner = btn.find(".spinner-border");
  spinner.remove();
}

export var ajaxConfigIcon = function(config, btn){
  config.type = 'POST';
  config.dataType = 'json';
  config.beforeSend = switchOnIconSpinner(btn);
  // config.complete = switchOffIconSpinner(btn);
  return config;
}

export var ajaxIcon = function(config, btn = false){
  $.ajax(ajaxConfigIcon(config, btn));
}

export var showSpinner = function(btn){
  let w = btn.css("width");
  if (w == undefined || w <= 0){
    w = "auto";
  }
  btn.css("width", w);
  const html = btn.html();
  btn.html(spinner() + '<span class="hide">' + html + '</span>');
}

export var hideSpinner = function(btn:JQuery){

  if (btn.width() == 0 || btn.css('width') == '0px'){
    btn.width('auto');
  }
  setTimeout(function(){
    const html = btn.find(".hide").html()
    btn.html(html);
  }, 400);
}

export var ajaxConfigSpinner = function(config, btn){
  config.type = 'POST';
  config.dataType = 'json';
  config.url = getAjaxUrl();
  config.data._ajax_nonce = getAjaxToken();
  if (btn) {
    config.beforeSend = showSpinner(btn);
    config.complete = hideSpinner(btn);
  }
  return config;
}

export var ajaxSpinner = function(config, btn=false){
  $.ajax(ajaxConfigSpinner(config, btn));
}


export var login = function(username, password, btn, redirect=''){
  const config = {
    data: {
      'action': 'pexam_login_ajax', //calls wp_ajax_nopriv_ajaxlogin
      'username': username,
      'password': password,
      'redirect_to': redirect,
    },
    success: function(data){
      if (data.loggedin == true){
        successToast("Anmeldung erfolgreich!", "", 2500);
        if (data.redirection != 'no'){
          window.location = '';
        } else {
          location.reload();
        }
      } else {
        resendMailToast(data.message, "Anmeldung fehlgeschlagen", 0);
      }
    }
  }
  ajaxSpin(config, btn);
}

export var recoverPassword = function(email, btn){
  const config = {
    data: {
      'action': 'recover_password',
      'email': email,
    },
    success: function(data){
      if (data.password_sent == true){
        successToast("Neues Passwort wurde versendet", "Erfolg", 5500, true);
      } else if (data.password_sent == "unknown_client") {
        errorToast("Email ist unbekannt", "Fehler", 0);
      } else {
        errorToast("Passwort konnte leider nicht versendet werden", "Fehler", 0);
      }
    }
  }
  ajaxSpinner(config, btn)
}


export var followAbCode = function(abCode){
  const config = {
    data: {
      action: "get_ab_code_url",
      abCode: abCode,
    },
    success: function(data){
      if (data.success){
        document.location.href = data.url;
      } else {
        errorToast(data.error, "Fehler", 0);
        $("#ab-code").addClass("is-invalid");
      }
    }
  }
  ajax(config);
}



export var sendFeedback = function(feedback){
  const config = {
    data: {
      action: "save_feedback",
      feedback: feedback,
    },
    success: function(data){
      if (data.success){
        successToast("Danke für dein Feedback!", "Erfolg", 8500, true);
        $("#feedback").val('');
      } else {
        errorToast("Dein Feedback konnte leider nicht gespeichert werden. Es wäre super, wenn du es in einer Mail an mail@pexam.de senden könntest :)", "Fehler", 0);
      }
    }
  }
  ajax(config);
}


export var loadCreateCourseModal = function(){
  const id = 'create-course-modal';
  const title = 'Kurs erstellen';
  const content = `<form class="form-material" id="add-new-course"><div class="mb-3 form-group"><label for="course-name-long" class="form-control-label">Name des Kurses</label><input type="text" id="course-name-long" name="course-name-long" class="form-control check-field " placeholder="Mathematik" value="" required=""></div></form>`
  const submitBtn = {
    text: 'Erstellen',
    class: 'create-new-course',
  }
  const modal = makeModal(id, title, content, submitBtn, true);
  modal.show();
  return modal;
}


export var loadCreateTutorModal = function(){
  const id = 'activate-new-tutor';
  const title = 'Neuen Tutor aktivieren';
  let content = '<div class="new-tutor-wrapper tutor-courses"><div class="input-group mb-2">\n' +
    '                        <input type="text" class="form-control" id="new-tutor-mail" placeholder="tutor@mail.de" aria-label="">\n' +
    '                        <span class="input-group-text text-info bg-light-info">E-Mail</span>\n' +
    '                    </div><hr>';
  content += '<h5 class="text-center">Kurse</h5>';
  content += '<div id="c-list"></div></div>';
  const submitBtn = {
    text: "Aktivieren",
    class: "activate-new-tutor-for-course",
  }
  const modal = makeModal(id, title, content, submitBtn);
  modal.show();
  loadTutorCoursesList("#c-list");
}


export var loadTutorCoursesList = function(holder){
  const config = {
    data: {
      action: "load_list_of_courses_for_tutor",
    },
    success: function(data){
      if (data.success){
        $(holder).html(data.html);
        const tutorActivator = new NewTutorActivator();
      } else {
        errorToast("Konnte Liste mit Kursen nicht laden", "Fehler", 0);
      }
    }
  }
  ajax(config);
}





